module.exports = __webpack_public_path__ + "da222c714a4e102dbb0965502b62a345.svg";